export const deriveInterviewAnswers = ({ absenceData, claimantData, contactData, formState }) => {
    return ({
        absenceData: { ...absenceData, ...formState?.values?.absenceData },
        claimantData: { ...claimantData, ...formState?.values?.claimantData },
        contactData: { ...contactData, ...formState?.values?.contactData },
    });
};
